module.exports = __webpack_public_path__ + "fonts/instagram-dark-2.aeb6827.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instagram-dark-2.svg
// module id = 875
// module chunks = 0